var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-roller"},_vm._l((8),function(dot,index){return _c('div',{key:index,style:({ '--dot-background': _vm.dotBackground })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }